import Reveal from "@/components/feature/Reveal";
import { clinic } from "@/mocks/clinic";
import { ReserveButton } from "@/components/layout/ReserveButton";
import { LineButton } from "@/components/layout/LineButton";

/**
 * 法務・案内系ページ共通のお問い合わせ導線。
 * 大きな色付きBOXは使わず、罫線・余白・テキストリンク中心の控えめなトーンで構成する。
 * 電話 / LINE / WEB予約 はすべて clinic の共通データを参照する。
 */
export default function LegalContactCta({
  heading,
  note,
}: {
  heading: string;
  note?: string;
}) {
  return (
    <section className="border-t border-background-300/70 bg-background-50 py-16 md:py-20 lg:py-24">
      <div className="u-container">
        <Reveal>
          <div className="flex flex-col gap-10 border-t border-foreground-950/12 pt-12 md:flex-row md:items-end md:justify-between md:gap-16">
            <div>
              <span className="en-eyebrow text-[10px] text-secondary-700 md:text-[11px]">CONTACT</span>
              <span className="mt-5 block h-px w-10 bg-accent-500" />
              <h2 className="mt-6 font-heading text-[20px] leading-[1.6] text-foreground-950 md:text-[24px]">
                {heading}
              </h2>
              {note ? (
                <p className="mt-4 max-w-xl text-[13px] leading-[2] text-foreground-700 md:text-sm">{note}</p>
              ) : null}
            </div>

            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href={clinic.telHref}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/20 px-7 py-3.5 text-[13.5px] text-foreground-900 transition-colors hover:border-accent-500 hover:bg-secondary-100/70"
              >
                <i className="ri-phone-line text-base" aria-hidden />
                電話する
              </a>
              <LineButton className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/20 px-7 py-3.5 text-[13.5px] text-foreground-900 transition-colors hover:border-accent-500 hover:bg-secondary-100/70">
                <i className="ri-line-fill text-base" aria-hidden />
                LINEで相談
              </LineButton>
              <ReserveButton className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-7 py-3.5 text-[13.5px] font-medium text-background-50 transition-colors hover:bg-primary-700">
                <i className="ri-calendar-check-line text-base" aria-hidden />
                WEB予約
              </ReserveButton>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}